<template>
  <div>
    <!-- BEGIN #subscribe -->
    <div id="subscribe" class="section">
      <!-- BEGIN container -->
      <div class="container">
        <!-- BEGIN row -->
        <div class="row ">
          <div
            class="col-md-12 justify-content-center mb-3"
            style="display: flex;"
          >
            <h3>
              Unleach the power of your medical data with womia <br />
              <div
                class="sparator mt-4"
                style=" border-bottom: 1px solid rgba(0, 0, 0, 0.2); margin: 0 -80px;"
              ></div>
            </h3>
          </div>
        </div>
        <div class="row">
          <div
            class="col-md-12 justify-content-center"
            style="display: flex; font-size: 20px;"
          >
            <div class="social subscription">
              <div class="social-list">
                <a href="#"><i class="fa fa-facebook"></i></a>
                <a href="#"><i class="fa fa-twitter"></i></a>
                <a href="https://www.linkedin.com/company/womia-io/"
                  ><i class="fa fa-linkedin"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END container -->

  <!-- END #subscribe -->
</template>
<script>
export default {
  name: "FooterSubscribe",
  data() {
    return {
      email: null,
      message: {}
    };
  },
  methods: {
    showMessage(message) {
      this.message = message;
    },
    subscribe() {
      this.message = {};
      this.$http.post(`subscription/subscribe`, { email: this.email }).then(
        response => {
          this.showMessage({
            text: "Thank you for subscribing!",
            alert: "alert-success"
          });
          this.email = null;
        },
        err => {
          // error callback
          if (
            err.body &&
            err.body.message === "subscription.email.alreadysubscribed"
          ) {
            this.showMessage({
              text: "Sorry, this email is already subscribed",
              alert: "alert-danger"
            });
          } else {
            this.showMessage({
              text: "Sorry, your email is not valid",
              alert: "alert-danger"
            });
          }
        }
      );
    }
  }
};
</script>
<style scoped>
.social .social-list a {
  padding: 0;
}

.social .social-intro,
.social .social-list,
.subscription .subscription-form,
.subscription .subscription-intro {
  display: table-cell;
  vertical-align: middle;
  width: 50%;
}
.subscription-form {
  padding: 0 30px;
}
.social .social-intro,
.social .social-list,
.subscription .subscription-form,
.subscription .subscription-intro {
  display: table-cell;
  vertical-align: middle;
  width: 50%;
}
.input-group .subscription {
  position: relative;
  display: table;
  border-collapse: separate;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.p-t-30 {
  padding-top: 30px;
}
.p-b-30 {
  padding-bottom: 30px;
}
.social-intro {
  display: table-cell;
  vertical-align: middle;
  width: 50%;
}
.social .social-list {
  text-align: center;
}
.social .social-list a {
  color: #999;
  font-size: 24px;
  padding-left: 15px;
}
.social .social-list a:hover {
  color: #474747;
}
</style>



// WEBPACK FOOTER //
// src/components/FooterSubscribe.vue